import {useEffect,useRef,useState} from 'react';
import {api} from '../api';

type ContactLabel={id:string;type:string;name:string};

/** Resolve old proposal links by identity, never by a guessed name match. */
export function useContactLabel(value:ContactLabel,onChange:(value:ContactLabel)=>void){
 const current=useRef({value,onChange});current.current={value,onChange};
 const [state,setState]=useState('');
 useEffect(()=>{
  if(!value.id||value.name&&value.type){setState('');return;}
  const controller=new AbortController();setState('Loading linked contact…');
  void api<ContactLabel[]>(`/api/contacts?id=${encodeURIComponent(value.id)}&limit=1`,{signal:controller.signal}).then(rows=>{
   if(controller.signal.aborted||current.current.value.id!==value.id)return;
   const found=rows.find(row=>row.id===value.id);
   if(found){current.current.onChange(found);setState('');}
   else setState('Linked contact details are unavailable. Resolve or remove this relationship before confirming.');
  }).catch(()=>{if(!controller.signal.aborted)setState('Linked contact details could not be loaded. Resolve or remove this relationship before confirming.');});
  return()=>controller.abort();
 },[value.id,value.name,value.type]);
 return state;
}
